import {
  EmailIcon,
  InstagramIcon,
  LinkIcon,
  QrCodeIcon,
  SmsIcon,
  SnapchatIconWithBackground,
} from '../Icons';
import { HTMLProps, PropsWithChildren } from 'react';
import {
  IconFacebook,
  IconLinkedin,
  IconMessenger,
  IconTwitter,
  IconWhatsApp,
} from '@justgiving/carepack-icons';

import styles from './SocialButton.module.scss';

type SocialButtonType =
  | 'facebook'
  | 'twitter'
  | 'email'
  | 'whatsapp'
  | 'messenger'
  | 'linkedin'
  | 'copy'
  | 'sms'
  | 'qrCode'
  | 'instagram'
  | 'snapchat';

interface SocialButtonProps extends PropsWithChildren {
  type: SocialButtonType;
  onClick?: () => void;
  as?: React.ElementType;
}

export const SocialButton: React.FC<
  SocialButtonProps & HTMLProps<HTMLElement>
> = ({ type, children, onClick, as = 'button', className = '', ...rest }) => {
  const Element = as;
  const Icon = iconMap[type];

  return (
    <Element
      id={`${type}-button`}
      className={`${styles.socialButton} ${className}`}
      onClick={onClick}
      {...rest}
    >
      <div className={`${styles.iconWrapper} ${styles[type]}`}>
        <Icon
          className={`${styles.icon} ${styles[type]}`}
          height={24}
          width={24}
        />
      </div>
      {children}
    </Element>
  );
};

const iconMap = {
  facebook: IconFacebook,
  twitter: IconTwitter,
  email: EmailIcon,
  whatsapp: IconWhatsApp,
  messenger: IconMessenger,
  linkedin: IconLinkedin,
  copy: LinkIcon,
  sms: SmsIcon,
  qrCode: QrCodeIcon,
  instagram: InstagramIcon,
  snapchat: SnapchatIconWithBackground,
};
